module.exports = __webpack_public_path__ + "Ubuntu-Italic.4b96047e4af086277cda.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Ubuntu/Ubuntu-Italic.ttf
// module id = ../../../../../src/assets/fonts_v2/Ubuntu/Ubuntu-Italic.ttf
// module chunks = styles